





































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeContratosStore from '@/components/RemuneracaoMedica/contratos/Store/BackofficeContratosStore'

@Component
export default class ComponentModalRemoveProfissional extends Vue {
  rmvprfLoading: boolean = false

  get getBackofficeContratosStore() {
    return getModule(BackofficeContratosStore, this.$store)
  }

  get removeProfissionalLoading() {
    return this.rmvprfLoading
  }

  set removeProfissionalLoading(value: boolean) {
    this.rmvprfLoading = value
  }

  get removeProfissionalList() {
    return this.getBackofficeContratosStore.modal.removeProfissionalList
  }

  closeModalRemoveProfissional() {
    this.getBackofficeContratosStore.clearRemoveProfissionalId()
    this.getBackofficeContratosStore.setShowModalRemoveProfissionalList(false)
  }

  async removerProfissional() {
    this.removeProfissionalLoading = true
    await this.getBackofficeContratosStore.removeProfissionalById()
    this.removeProfissionalLoading = false
    this.closeModalRemoveProfissional()
  }
}
